import './Header.css';
import useMainStore from '../../store/mainState';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ReactComponent as WalletIcon } from "./../../assets/icons/wallet.svg"
import { useTranslation } from 'react-i18next';
import useLogout from '../../hooks/useLogout';

interface HeaderProps {
  setIsSignInOpen: (value: boolean) => void;
  setIsSignUpOpen: (value: boolean) => void;
}

const Header = ({ setIsSignInOpen, setIsSignUpOpen }: HeaderProps) => {
  const { setIsCollapsed, isCollapsed, user, setActiveItem, setActiveSubItem } = useMainStore();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();
  const logout = useLogout();

  const navigateWithReferral = (path: string) => {
    const referral = searchParams.get('referral');
    navigate(referral ? `${path}?referral=${referral}` : path);
  };


  const balance = user?.Balance ? (user.Balance.amount + user.Balance.onHold) : 0;

  return (
    <header className="header">
      <div className="header-container">
        <div className="header-left">
          <div className="hamburger-menu">
            <button className="hamburger-button" onClick={() => setIsCollapsed(!isCollapsed)}>
              <img src={require("../../assets/images/hamburgerMenu.png")} alt="" />
            </button>
          </div>
          <div className="header-logo">
            <button onClick={() => { setActiveItem(null); setActiveSubItem('All'); navigateWithReferral("/") }}>
              <img src={require("../../assets/images/logo.png")} alt="" />
            </button>
          </div>
        </div>

        {user && (
          <div className="header-center">
            <div className="header-balance-wrap">
              <div className="header-balance">
                <span className="header-balance-amount">${Number(balance || 0).toFixed(2)}</span>
              </div>
              <button
                className="header-deposit-btn"
                onClick={() => navigateWithReferral("/payment")}
                aria-label={t('common.wallet')}
              >
                <WalletIcon />
                <span className="header-deposit-text">{t('common.wallet')}</span>
              </button>
            </div>
          </div>
        )}

        <div className="header-actions">
          {user ? (
            <button
              className="header-signout-btn"
              onClick={logout}
              aria-label={t('common.signOut')}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                <polyline points="16 17 21 12 16 7"></polyline>
                <line x1="21" y1="12" x2="9" y2="12"></line>
              </svg>
              <span className="header-signout-text">{t('common.signOut')}</span>
            </button>
          ) : (
            <div className="auth-buttons">
              <button className="signin-btn" onClick={() => setIsSignInOpen(true)}>{t('common.signIn')}</button>
              <button className="signup-btn" onClick={() => setIsSignUpOpen(true)}>{t('common.signUp')}</button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
